module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-mobile",
    attrs: {
      "id": "control-panel"
    }
  }, [_c('div', {
    staticClass: "column title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "column is-narrow"
  }, [(_vm.showPlayer) ? _c('player', {
    staticClass: "player",
    attrs: {
      "is-paused": _vm.isPlayerPaused
    },
    on: {
      "restart": _vm.restartPlayer,
      "toggle": _vm.togglePlayer
    }
  }) : _vm._e(), (_vm.feedback) ? _c('div', {
    staticClass: "props"
  }, [_c('abbr', {
    staticClass: "prop speech",
    class: {
      off: !_vm.feedback.speech.enabled
    },
    attrs: {
      "title": _vm.tokens['tit_speech']
    }
  }), _c('abbr', {
    staticClass: "prop syllab",
    class: {
      off: !_vm.feedback.syllabification.enabled
    },
    attrs: {
      "title": _vm.tokens['tit_syllab']
    }
  }, [(_vm.feedback.syllabification.enabled) ? _c('span', [_vm._v(_vm._s(_vm.feedback.syllabification.threshold.value))]) : _vm._e()])]) : _vm._e(), (_vm.questionnaire && _vm.questionnaire.length) ? _c('div', {
    staticClass: "props"
  }, [_c('abbr', {
    staticClass: "prop questionnaire",
    attrs: {
      "title": _vm.tokens['tit_quest']
    }
  }, [_vm._v(_vm._s(_vm.correctAnswers))])]) : _vm._e(), _c('div', {
    staticClass: "menu"
  }, [(_vm.textLength) ? [_c('div', {
    staticClass: "navigation"
  }, [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_prev']
    }
  }, [_c('button', {
    staticClass: "icon-btn prev",
    class: {
      disabled: !_vm.pageIndex
    },
    on: {
      "click": _vm.prevPage
    }
  })]), _c('div', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.dispPage))]), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_next']
    }
  }, [_c('button', {
    staticClass: "icon-btn next",
    class: {
      disabled: _vm.pageIndex === _vm.textLength - 1
    },
    on: {
      "click": _vm.nextPage
    }
  })])]), _c('div', {
    staticClass: "separator"
  })] : _vm._e(), (_vm.showOptionsButton) ? [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_settings']
    }
  }, [_c('button', {
    staticClass: "icon-btn settings",
    on: {
      "click": _vm.showOptions
    }
  })]), _c('div', {
    staticClass: "separator"
  })] : _vm._e(), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_close']
    }
  }, [_c('button', {
    staticClass: "icon-btn close",
    on: {
      "click": _vm.close
    }
  })])], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65739ed1"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/controlPanel.vue
// module id = 431
// module chunks = 0